import styled from '@emotion/styled';
import { Select as SelectUI } from '@mui/material';

export const Select = styled(SelectUI)`
  height: 100%;
`;
